import {
  NOTICE_PERIOD_SELECT_OPTIONS,
  availabilityToSelectValue,
  selectValueToAvailability
} from '../constants/noticePeriod';
import { CANDIDATE_INPUT_ERROR_CLASS, CANDIDATE_SELECT_CLASS } from '../constants/candidateFormStyles';

/**
 * Notice period — single dropdown (Immediate, 10–90 days) for Salary & Experience 4-column grid.
 */
export default function NoticePeriodField({
  value = '',
  onChange,
  error,
  required = false,
  selectClassName
}) {
  const selectValue = availabilityToSelectValue(value);
  const selectClass = selectClassName || (error ? CANDIDATE_INPUT_ERROR_CLASS : CANDIDATE_SELECT_CLASS);

  return (
    <div className="min-w-0">
      <div className="field-with-label">
        <select
          className={selectClass}
          value={selectValue}
          onChange={e => onChange(selectValueToAvailability(e.target.value))}
        >
          {NOTICE_PERIOD_SELECT_OPTIONS.map(opt => (
            <option key={opt.value || 'empty'} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </select>
        <label>
          Notice period{required ? ' *' : ''}
        </label>
      </div>
      {error && <p className="text-xs text-red-600 mt-1">{error}</p>}
    </div>
  );
}
